<template>
    <header class="py-6">
        <div class="flex items-center justify-between gap-4">
            <Brand :appName="appName" />

            <nav
                class="hidden md:flex items-center gap-6 text-sm text-white/80"
            >
                <a
                    :href="landingHomePageUrl"
                    class="hover:text-white"
                >
                    Home
                </a>
                <a
                    :href="helpCenterHomeUrl"
                    class="hover:text-white"
                >
                    Help Center
                </a>
            </nav>

            <div class="flex items-center gap-2">
                <a
                    :href="authLoginUrl"
                    class="px-4 py-2 rounded-lg text-sm text-white/80 hover:text-white"
                >
                    Login
                </a>
                <a
                    :href="authRegisterUrl"
                    class="px-4 py-2 rounded-lg text-sm bg-white text-gray-900 hover:bg-stone-100"
                >
                    Start free
                </a>
            </div>
        </div>
    </header>
</template>

<script setup lang="ts">
    import Brand from '@/Marketing/Shared/Component/Brand.vue'
    import { UrlFactory } from '@/Shared/Url/UrlFactory'

    interface HelpCenterHeaderProps {
        appName: string
    }

    defineProps<HelpCenterHeaderProps>()
    const urlFactory = new UrlFactory()
    const authLoginUrl = urlFactory.makeAuthLoginPageUrl()
    const authRegisterUrl = urlFactory.makeAuthRegisterPageUrl()
    const helpCenterHomeUrl = urlFactory.makeHelpCenterHomePageUrl()
    const landingHomePageUrl = urlFactory.makeLandingHomePageUrl()
</script>
